import { useState } from "react";
import { Link } from "react-router-dom";
//---------------------------------------------
import Modal from "src/components/common/modal";
import { useMyStore } from "src/components/main/mainStore";
import { 
    MyFormData, 
    Select, 
    dateDurationCalc, 
    myAxios, 
    objAscSort, 
} from "src/components/common/functions";
//---------------------------------------------
const title = "PerDiem";
export default function PerDiemForm({
    keyword, 
    history, 
    closeIt, 
    curWeekStart, 
    curWeekEnd, 
    setPerDiems, 
    users, 
    projects, 
    perDiems, 

    perDiemHashKey,
    projectHashKey, 
    email, 
    startDate, 
    endDate, 
    hotelName, 
    hotelAddress,
    notes, 
    approverEmail,  
    data, 
    formId, 
    excelId, 
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const handleSubmit = async e => {
        const target = e.currentTarget; // await below will make `e.currentTarget` become `null`
        e.preventDefault();
        const formData0 = new MyFormData();
        //-------------------------------------------------
        setShowLoader(true);
        formData0.append("userEmail", curRequester?.value);
        const poRes = await myAxios("perDiem/validate.php", formData0);
        setShowLoader(false);
        if(!poRes) return;
        //-------------------------------------------------
        const ranges = perDiemHashKey?
        poRes.data.filter(d => d.perDiemHashKey !== perDiemHashKey)
        :
        poRes.data;
        for(let range of ranges){
            const {startDate, endDate} = range;
            const before = curTo < startDate;
            const after = curFrom > endDate;
            const valid = before || after;
            if(!valid){
                setInvalidText(range);
                window.alert("Time conflict. Please check.");
                return;
            }else{
                setInvalidText("");
            }
        }
        const formData = new MyFormData(target);
        if(!formData.get("projectHashKey")){
            window.alert("The project is not selected.");
            return;
        }
        if(!formData.get("approverEmail")){
            window.alert("The approver is not selected.");
            return;
        }
        formData.append("form", "perDiemForm");
        formData.append("read", "no");
        formData.append("folderId", user.folderId);
        formData.append("duration", dateDurationCalc(formData.get("startDate"), formData.get("endDate")));
        formData.append("requestDates",formData.get("projectName") + " " + (formData.get("startDate") === formData.get("endDate")?
        formData.get("startDate"):"from " + formData.get("startDate") + " to " + formData.get("endDate")));
        //-----------------------------------
        setShowLoader(true);
        const res = await myAxios(
            formData.get("action") === "Add"?
            "perDiem/createPerDiem.php":
            "perDiem/updatePerDiem.php", 
            formData
        );
        setShowLoader(false);
        if(!res) return;
        //-----------------------------------
        if(formData.get("action") === "Add"){
            setPerDiems(curWeekStart, curWeekEnd, [...perDiems, res.data].sort((a, b) => objAscSort(a, b, "submitTime")));
        }else{
            const newPerDiems = perDiems.map(thisPerDiem => thisPerDiem.perDiemHashKey === formData.get("perDiemHashKey")?res.data:thisPerDiem);
            setPerDiems(curWeekStart, curWeekEnd, newPerDiems);
        }
        history.push(`/${title}`);
    }
    //---------------------------------------------
    const defaultApprover = approverEmail?
    users.filter(u => u.email === approverEmail).map(u => ({...u, label: u.userName, value: u.email}))[0]
    :null;
    const defaultProject = projectHashKey?
    projects.filter(u => u.projectHashKey === projectHashKey).map(u => ({...u, label: u.projectName, value: u.projectHashKey}))[0]
    :null;
    const defaultRequester = email?
    (users.filter(u => u.email === email).map(u => ({...u, value: u.email, label: u.userName}))[0])
    :(users.filter(u => u.email === user.email).map(u => ({...u, value: u.email, label: u.userName}))[0]);
    const defaultDepartment = (users.filter(u => u.email === defaultRequester.value).map(u => u.department)[0]);
    //---------------------------------------------
    const [curRequester, setRequester] = useState(defaultRequester);
    const [curApprover, setApprover] = useState(defaultApprover);
    const [curProject, setProject] = useState(defaultProject);
    const [curFrom, setFrom] = useState(startDate || "");
    const [curTo, setTo] = useState(endDate || "");
    const [curDepartment, setDepartment] = useState(defaultDepartment || "");
    const [invalidText, setInvalidText] = useState("");
    //---------------------------------------------
    return(
        <Modal
            closeIt = {closeIt}
            title = {keyword}
            width = "800px"
            maxWidth = "100%"
            handleFormSubmit = {handleSubmit}
            actionKey = {keyword}
        >
            <div>
                <input
                    className = "nodisplay" readOnly
                    name = "action" value = {keyword}
                />
                <input
                    className = "nodisplay" readOnly
                    name = "form" value = {"dayOffForm"}
                />
                <input
                    className = "nodisplay" readOnly
                    name = "formId" value = {formId}
                />
                <input
                    className = "nodisplay" readOnly 
                    name = "excelId" value = {excelId}
                />
                <input
                    className = "nodisplay" readOnly
                    name = "curData" value = {JSON.stringify(data?JSON.parse(data):[])}
                />
                {perDiemHashKey?
                <input
                    className = "nodisplay" readOnly
                    name = "perDiemHashKey" value = {perDiemHashKey}
                />:null}
                <div>
                    {invalidText?
                    <div className = "my-4 mx-3 text-danger font-weight-bold">
                        <span className = "mr-1">
                            conflict with
                        </span>
                        <Link to = {`/${title}/${invalidText.perDiemHashKey}`}>
                        {invalidText.project} from {invalidText.startDate} to {invalidText.endDate}
                        </Link>
                    </div>
                    :<></>}
                </div>
                <div className = "d-flex align-items-center mt-3 mb-2">
                    <div className = "font-weight-bold mr-3 required-field">Request Date:</div>
                    <div className = "d-flex align-items-center flex-grow-1 mr-3">
                        <label htmlFor = "startDate" className = "mb-0 mr-2">From:</label>
                        <input
                            id = "startDate"
                            required
                            type = "date"
                            min = "1900-01-01"
                            max = {curTo || "2999-12-31"}
                            className = "form-control flex-grow-1"
                            name = "startDate"
                            value = {curFrom}
                            onChange = {e => {
                                setFrom(e.currentTarget.value);
                                setInvalidText("");
                            }}
                        />
                    </div>
                    <div className = "d-flex align-items-center flex-grow-1">
                        <label htmlFor = "endDate" className = "mb-0 mr-2">To:</label>
                        <input
                            id = "endDate"
                            required
                            type = "date"
                            min = {curFrom || "1900-01-01"}
                            max = "2999-12-31"
                            className = "form-control flex-grow-1"
                            name = "endDate"
                            value = {curTo}
                            onChange = {e => {
                                setTo(e.currentTarget.value);
                                setInvalidText("");
                            }}
                            
                        />
                    </div>
                </div>
                <div className = "blk5 mb-2">
                    <label htmlFor = "requester" className = "font-weight-bold required-field mb-0 mr-3">Requester:</label>
                    <div className = "flex-grow-1">
                        <Select
                            inputId = "requester"
                            isDisabled = {user.projects === "no"}
                            value = {curRequester}
                            onChange = {e => {
                                setRequester(e);
                                setDepartment(e?.department);
                                setInvalidText("");
                            }}
                            options = {users.map(u => ({...u, value: u.email, label: u.userName, department: u.department}))}
                        />
                        <input
                            className = "nodisplay" readOnly
                            name = "requester" value = {users.filter(u => curRequester?.value === u.email)[0]?.userName}
                        />
                        <input
                            className = "nodisplay" readOnly
                            name = "requesterEmail" value = {curRequester?.value}
                        />
                    </div>
                </div>
                {users.filter(u => curRequester?.value === u.email)[0]?.outside &&
                users.filter(u => curRequester?.value === u.email)[0]?.outside !== "no"?
                    <div className = "mb-2">
                        <span className = "mr-2">{users.filter(u => curRequester?.value === u.email)[0]?.outside}</span>
                        <span>{users.filter(u => curRequester?.value === u.email)[0]?.btlNumber}</span>
                        <input
                            className = "nodisplay" readOnly
                            name = "btlNumber" value = {users.filter(u => curRequester?.value === u.email)[0]?.btlNumber}
                        />
                    </div>:null}
                <div className = "blk5 mb-2">
                    <label htmlFor = "department" className = "font-weight-bold required-field mb-0 mr-3">Department:</label>
                    <input
                        id = "department"
                        className = "form-control flex-grow-1" readOnly
                        name = "department" value = {curDepartment}
                    />
                </div>
                <div className = "blk5 mb-2">
                    <label htmlFor = "project" className = "font-weight-bold required-field mb-0 mr-3">Project:</label>
                    <div className = "flex-grow-1">
                        <Select
                            inputId = "project"
                            value = {curProject}
                            onChange = {e => {
                                setProject(e);
                                setInvalidText("");
                            }}
                            options = {projects.map(p => (
                                    {...p, 
                                        label: p.projectName, 
                                        value: p.projectHashKey
                                    }
                                ))
                            }
                        />
                        <input
                            className = "nodisplay" readOnly
                            name = "projectHashKey" value = {curProject?.projectHashKey || ""}
                        />
                        <input
                            className = "nodisplay" readOnly
                            name = "projectName" value = {curProject?.projectName || ""}
                        />
                    </div>
                </div>
                <div className = "blk5 mb-2">
                    <label htmlFor = "hotelName" className = "font-weight-bold required-field mb-0 mr-3">Hotel Name:</label>
                    <input
                        id = "hotelName"
                        required
                        name = "hotelName"
                        className = "form-control flex-grow-1"
                        defaultValue = {hotelName}
                    />
                </div>
                <div className = "blk5 mb-2" style = {{display: "flex"}}>
                    <label htmlFor = "hotelAddress" className = "font-weight-bold required-field mb-0 mr-3">Hotel Address:</label>
                    <input
                        id = "hotelAddress"
                        required
                        name = "hotelAddress"
                        className = "form-control flex-grow-1"
                        defaultValue = {hotelAddress}
                    />
                </div>
                <div className = "blk5 mb-2" style = {{display: "flex"}}>
                    <label htmlFor = "approver" className = "font-weight-bold required-field mb-0 mr-3">Approver:</label>
                    <div className = "flex-grow-1">
                        <Select
                            inputId = "approver"
                            value = {curApprover}
                            onChange = {e => {setApprover(e)}}
                            options = {
                                users.filter(thisUser => 
                                    thisUser.purchases === "approver" 
                                ).map(thisUser => (
                                    {...thisUser, 
                                        label: thisUser.userName, 
                                        value: thisUser.email
                                    }
                                ))
                            }
                        />
                        <input
                            className = "nodisplay" readOnly
                            name = "approverEmail" value = {curApprover?.email || ""}
                        />
                        <input
                            className = "nodisplay" readOnly
                            name = "approver" value = {curApprover?.label || ""}
                        />
                    </div>
                </div>
                <label htmlFor = "notes" className = "h4 float-left mb-0 my-2">
                    Notes:
                </label>
                <textarea id = "notes" name = "notes" defaultValue = {notes || ""} className = "form-control mb-3" style = {{width: "100%"}}/>
            </div>
        </Modal>
    )
}